// named export (recommended)
export const TRAVEL_TOURISM = {
    // section: ["overviewSection", "roiInvestorBenefits", "roiInvestorBenefitsNew", "operationModelsNew", "communicationChannel"],
    href: "/investments/travel-and-tourism",
    overviewSection: {
        sectionId: "travelOverview",
        title: "Overview",
        subtitle:
            "The RSL Lifestyle Module allows investors to earn from luxury tourism and corporate partnerships.",
        cards: [
            {
                title: "Investment Options",
                body: "Invest with your own luxury vehicle or co-invest",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Exclusive Operations",
                body: "Vehicles operate under RSL's premium corporate contracts and tourism partnerships",
                arrow: "/img/app/Right-bottom-arrow.svg",
            },
            {
                title: "Prime Locations",
                body: "Dubai Mall, 5-star hotels & resorts, Airports Luxury lifestyle hubs",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Not Ride-Hailing",
                body: "Exclusively for premium tourism, not ride-hailing platforms",
            },
        ],
        button: { text: "Invest Now", link: "#" },
    },
    roiInvestorBenefits: {
        sectionId: "operationalBenefitsForInvestors",
        title: "Operational Benefits for Investors",
        subtitle:
            "Choose which suits you better",
        image: {
            src: "/img/investments/travel/operational.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Invest Now", link: "#" },
        width: "75%",
    },
    roiInvestorBenefitsNew: {
        sectionId: "ROIInvestorBenefits",
        title: "ROI & Investor Benefits",
        subtitle:
            "Choose which suits you better",
        rows: [
            {
                item: "Investor provides car + Investor’s\nOwn Driver",
                monthly: "7,000 – 10,000",
                annual: "20–25% per annum",
            },
            {
                item: "Investor provides car + RSL\nAcademy Driver",
                monthly: "5,500 – 8,000",
                annual: "15–20% per annum",
            },
            {
                item: "RSL provides car + RSL Academy\nDriver",
                monthly: "5,000 – 7,000",
                annual: "12–18% per annum",
            },
            {
                item: "RSL provides car + Investor’s\nOwn Driver",
                monthly: "6,500 – 9,000",
                annual: "18–22% per annum",
            },
        ],
        button: { text: "Invest Now", link: "#" },
    },
    operationModelsNew: {
        sectionId: "investorVehicleDetails",
        title: "Operation Models",
        subtitle:
            "Choose which suits you better",
        tabData: [{
            label: "Investor Owned Vehicle",
            value: "INVESTOR",
            tableData: [
                { item: "Registration Fee", amount: "2,100.00" },
                { item: "RMS Tracking", amount: "3,900" },
                { item: "Driver Fee (If Required)", amount: "10,000.00" },
            ],
            tableFooter: [{
                item: "Total",
                amount: "16,000.00(excluding insurance)"
            }],
            listData: {
                title: "Investor-Owned Vehicle",
                items: [{
                    text: "Investor provide their own driver."
                }, {
                    text: "RSL registers, insures, and onboards the vehicle."
                }, {
                    title: "Driver Options:",
                    nested: [
                        { text: "Investor provides their own driver." },
                        {
                            text:
                                "RSL can assign a driver from RSL Academy at a cost of AED 10,000.00",
                        },
                    ]
                }, {
                    text: "Once assigned, the investor and their driver are fully responsible for managing the vehicle under RSL's corporate contracts and touris, operations."
                }]
            }
        }, {
            label: "RSL-Purchased Vehicle",
            value: "RSL",
            tableData: [
                { item: "RMS Tracking", amount: "3,900" },
                { item: "Registration Fee", amount: "2,100.00" },
                { item: "Driver Fee (If Required)", amount: "10,000.00" },
            ],
            tableFooter: [{
                item: "Total",
                amount: "16,000.00(including insurance)"
            }],
            listData: {
                title: "Investor-Owned Vehicle",
                items: [{
                    text: "Investor provide their own driver."
                }, {
                    title: "Driver Options:",
                    nested: [
                        { text: "Investor provides their own driver." },
                        {
                            text:
                                "RSL can assign a driver from RSL Academy at a cost of AED 10,000.00",
                        },
                    ]
                }, {
                    text: "RSL registers, insures, and onboards the vehicle."
                }, {
                    text: "Once assigned, the investor and their driver are fully responsible for managing the vehicle under RSL's corporate contracts and touris, operations."
                }]
            }
        }],
        button: { text: "Invest Now", link: "#" },
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        title: "Communication Channel",
        subtitle:
            "Choose which suits you better",
        bottomHeader: "RSL ensures smooth communication and transparency for all investors and drivers:",
        cardData: [
            {
                heading: "Call Center (UAE):",
                iconSrc: "/img/investments/phone.svg",
                iconAlt: "Phone",
                url: [
                    {
                        href: "tel:+97143977746",
                        label: "+971 4 397 7746"
                    }
                ]
            },
            {
                heading: "Email (Investors):",
                iconSrc: "/img/investments/email.svg",
                iconAlt: "Email",
                url: [
                    {
                        href: "mailto:investors@royalsmartlifestyle.com",
                        label: "investors@royalsmartlifestyle.com"
                    }
                ]
            },
            {
                heading: "Websites",
                iconSrc: "/img/investments/globe.svg",
                iconAlt: "Globe",
                url: [{
                    href: "https://www.royalsmartlimousine.com",
                    label: "https://www.royalsmartlimousine.com"
                }]
            }
        ],
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
};

export const TRAVEL_TOURISM_PAGE = {
    investInFleets: {
        sectionId: "investInFleets",
        title: "Invest in our Fleets",
        subtitle: "Choose which suits you better",
        image: {
            src: "/images/bannerImage/1761499573891.png",
            alt: "RSL luxury fleet – 60+ corporate partners, 1400+ drivers, highest ROI in UAE"
        },
        button: { text: "Invest Now", link: "#" },
    },
    investorBenefits: {
        sectionId: "investorBenefits",
        title: "Investor Benefits",
        subtitle: "Choose which suits you better",
        image: {
            src: "/images/bannerImage/tourist_fleet.png",
            alt: "Investor benefits – access to the tourism market, 60+ corporate clients, premium tourism rates, you keep full ownership, turn cost into income stream"
        },
    },
    operationModelsNew: {
        sectionId: "operationModelsNew",
        title: "Operation Models",
        subtitle: "Choose which suits you better",
        tabData: [{
            label: "Investor Owned Vehicle",
            value: "INVESTOR",
            tableData: [
                { item: "Registration Fee", amount: "3,500" },
                { item: "RMS Tracking", amount: "3,900" },
                { item: "Driver Fee (If Required)", amount: "10,000.00" },
            ],
            tableFooter: [{
                item: "Total",
                amount: "17,400(excluding insurance)"
            }],
            listData: {
                title: "Investor-Owned Vehicle",
                items: [{
                    text: "Investor provides their own eligible vehicle."
                }, {
                    text: "RSL registers, insures, and onboards the vehicle."
                }, {
                    title: "Driver options:",
                    nested: [
                        { text: "Investor provides their own driver." },
                        {
                            text:
                                "RSL can assign a driver from RSL Academy at a cost of AED 10,000.00",
                        },
                    ]
                }, {
                    text: "Once assigned, the investor and their driver are fully responsible for managing the vehicle under RSL’s corporate contracts and tourism operations."
                }]
            }
        }
        // "RSL-Purchased Vehicle" tab hidden - uncomment to bring it back
        // , {
        //     label: "RSL-Purchased Vehicle",
        //     value: "RSL",
        //     tableData: [
        //         { item: "RMS Tracking", amount: "3,900" },
        //         { item: "Registration Fee", amount: "2,100.00" },
        //         { item: "Driver Fee (If Required)", amount: "10,000.00" },
        //     ],
        //     tableFooter: [{
        //         item: "Total",
        //         amount: "16,000.00(including insurance)"
        //     }],
        //     listData: {
        //         title: "Investor-Owned Vehicle",
        //         items: [{
        //             text: "Investor provide their own driver."
        //         }, {
        //             title: "Driver Options:",
        //             nested: [
        //                 { text: "Investor provides their own driver." },
        //                 {
        //                     text:
        //                         "RSL can assign a driver from RSL Academy at a cost of AED 10,000.00",
        //                 },
        //             ]
        //         }, {
        //             text: "RSL registers, insures, and onboards the vehicle."
        //         }, {
        //             text: "Once assigned, the investor and their driver are fully responsible for managing the vehicle under RSL's corporate contracts and touris, operations."
        //         }]
        //     }
        // }
        ],
        button: { text: "Invest Now", link: "#" },
    },
    tabData: [
        {
            label: "Investor Owned Vehicle",
            value: "INVESTOR",
            description: "Investor provides an eligible luxury vehicle",
            data: {
                participationCosts: {
                    sectionId: "operationModels",
                    title: "Investor Participation Costs",
                    subtitle:
                        "Choose which suits you better",
                    tableData: [
                        { item: "Registration Fee", amount: "2,100.00" },
                        { item: "RMS Tracking", amount: "3,900" },
                        { item: "Driver Fee (If Required)", amount: "10,000.00" },
                    ],
                    tableFooter: [{
                        item: "Total",
                        amount: "16,000.00(excluding insurance)"
                    }],
                    button: { text: "Invest Now", link: "#" },
                },
                roiInvestorBenefits: {
                    sectionId: "overview",
                    title: "The RSL Lifestyle Module allows investors to earn from luxury tourism and corporate partnerships",
                    subtitle:
                        "Overview",
                    image: {
                        src: "/img/investments/travel/ownedVehicle.svg",
                        alt: "Investor Owned Vehicle"
                    },
                    bgcolor: "#ffffff",
                    width: "100%"
                },
                roiInvestorBenefitsNew: {
                    sectionId: "ROIInvestorBenefits",
                    title: "ROI & Investor Benefits",
                    subtitle:
                        "Choose which suits you better",
                    rows: [
                        {
                            item: "Investor provides car + Investor's\nOwn Driver",
                            monthly: "7,000 – 10,000",
                            annual: "20–25% per annum",
                        },
                        {
                            item: "Investor provides car + RSL\nAcademy Driver",
                            monthly: "5,500 – 8,000",
                            annual: "15–20% per annum",
                        }
                    ],
                    button: { text: "Invest Now", link: "#" },
                },
                communicationChannel: {
                    sectionId: "RSLSuperApp",
                    image: {
                        src: "/images/bannerImage/rsl_super_app.svg",
                        alt: "RSL SUPER APP"
                    }
                }
            }
        }, {
            label: "RSL-Purchased Vehicle",
            value: "RSL",
            description: "Up to 4 investors co-invest in a vehicle",
            data: {
                participationCosts: {
                    sectionId: "operationModels",
                    title: "Investor Participation Costs",
                    subtitle:
                        "Choose which suits you better",
                    tableData: [
                        { item: "Registration Fee", amount: "3,200.00" },
                        { item: "RMS Tracking", amount: "3,900" },
                        { item: "Driver Fee (If Required)", amount: "10,000.00" },
                    ],
                    tableFooter: [{
                        item: "Total",
                        amount: "17,100.00(excluding insurance)"
                    }],
                    button: { text: "Invest Now", link: "#" },
                },
                roiInvestorBenefits: {
                    sectionId: "overview",
                    title: "The RSL Lifestyle Module allows investors to earn from luxury tourism and corporate partnerships",
                    subtitle:
                        "Overview",
                    image: {
                        src: "/img/investments/travel/purchasedVehicle.svg",
                        alt: "RSL-Purchased Vehicle"
                    },
                    bgcolor: "#ffffff",
                    width: "100%"
                },
                roiInvestorBenefitsNew: {
                    sectionId: "ROIInvestorBenefits",
                    title: "ROI & Investor Benefits",
                    subtitle:
                        "Choose which suits you better",
                    rows: [
                        {
                            item: "RSL provides car + RSL Academy\nDriver",
                            monthly: "5,000 – 7,000",
                            annual: "12–18% per annum",
                        },
                        {
                            item: "RSL provides car +\n Investor's Own Driver",
                            monthly: "6,500 – 9,000",
                            annual: "18–22% per annum",
                        }
                    ],
                    button: { text: "Invest Now", link: "#" },
                },
                communicationChannel: {
                    sectionId: "RSLSuperApp",
                    image: {
                        src: "/images/bannerImage/rsl_super_app.svg",
                        alt: "RSL SUPER APP"
                    }
                }
            }
        }
    ]
}